import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { UsersDashboardInfoResponse } from '@edtech-ui/core/models/admin-panel/admin-panel-models';
import { AdminDashboardService } from '@edtech-ui/core/services/admin-panel/adminDashboard.service';
import { catchError, of, tap } from 'rxjs';
import { SuperAdminInstitutionDialogComponent } from '../super-admin-institution-dialog/super-admin-institution-dialog.component';
import { AdminStudentPlatformDashboardComponent } from '../../admin-student-platform/admin-student-platform-dashboard/admin-student-platform-dashboard.component';

@Component({
	selector: 'app-super-admin-dashboard',
	standalone: true,
	imports: [CommonModule, MatIconModule, HttpClientModule, AdminStudentPlatformDashboardComponent],
	templateUrl: './super-admin-dashboard.component.html',
	styleUrl: './super-admin-dashboard.component.scss'
})
export class SuperAdminDashboardComponent {

	tenantName = '';
	adminName = '';
	adminEmail = '';
	recentActivities: any[] = [];
	quickActions: any[] = [];
	isLoading = false;

	constructor(private _teacherService: AdminDashboardService,
		private dialog: MatDialog,
	) { }

	ngOnInit(): void {
	}


	cardData = [
		{ title: 'Total Institutions', value: '12', icon: 'account_balance' },
		{ title: 'Active Subscriptions', value: '2', icon: 'subscriptions' },
		{ title: 'Total Teachers', value: '3', icon: 'person' },
		{ title: 'Total Students', value: '3', icon: 'school' },
		{ title: 'Revenue This Month', value: '4', icon: 'currency_rupee' },
		{ title: 'Pending Tickets', value: '5', icon: 'confirmation_number' }
	];


	openInstitutionsDialogBox(): void {
		this.dialog.open(SuperAdminInstitutionDialogComponent, {
			panelClass: 'custom-dialog-container',
		});
	}
}
